"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approval = void 0;
const ant_design_vue_1 = require("ant-design-vue");
const complex_plugin_1 = require("complex-plugin");
const vue_1 = require("vue");
const approvalContent = {
    agree: '请确认是否通过审批！',
    reject: '请确认是否驳回审批！',
    refuse: '请确认是否拒绝审批！'
};
const approval = function (act, next) {
    let opinions = '';
    const modal = ant_design_vue_1.Modal.confirm({
        title: '审批',
        okButtonProps: {
            disabled: true
        },
        content: (0, vue_1.h)('div', [
            (0, vue_1.h)('div', {
                style: {
                    margin: '8px 0'
                }
            }, approvalContent[act]),
            (0, vue_1.h)(ant_design_vue_1.Textarea, {
                placeholder: '请输入审批意见',
                onInput: (e) => {
                    opinions = e.target.value || '';
                    modal.update({
                        okButtonProps: {
                            disabled: !opinions
                        },
                    });
                }
            })
        ]),
        onOk: function () {
            if (opinions) {
                next(opinions);
            }
            else {
                complex_plugin_1.notice.showMsg('请输入审批意见！', 'error');
            }
        }
    });
};
exports.approval = approval;
